<template>
  <div class="row footer">
    <div class="footer__container d-flex fill-width">
      <div class="footer__column d-flex">
        <h4 class="footer__heading">{{ $t("footer.support.title") }}</h4>
        <div class="footer__link-container footer__link-container--first">
          <a
            :href="$t('footer.support.customer_services.url')"
            target="_blank"
            class="footer__link body2"
          >
            {{ $t("footer.support.customer_services.text") }}
          </a>
          <p class="footer__link">
            {{ $t("footer.support.version", { version: version }) }}
          </p>
        </div>
      </div>
      <div class="footer__column d-flex">
        <h4 class="footer__heading">{{ $t("footer.corporate.title") }}</h4>
        <div class="footer__link-container">
          <a
            :href="$t('footer.corporate.terms.url')"
            target="_blank"
            class="footer__link body2"
          >
            {{ $t("footer.corporate.terms.text") }}
          </a>
          <a
            :href="$t('footer.corporate.privacy.url')"
            target="_blank"
            class="footer__link body2"
          >
            {{ $t("footer.corporate.privacy.text") }}
          </a>
        </div>
      </div>
      <div class="footer__column d-flex">
        <h4 class="footer__heading">{{ $t("footer.contact.title") }}</h4>
        <div class="footer__link-container">
          <p class="footer__link">{{ $t("footer.contact.address") }}</p>
          <p class="footer__link">{{ $t("footer.contact.postal") }}</p>
          <p class="footer__link">{{ $t("footer.contact.phone") }}</p>
          <p class="footer__link">{{ $t("footer.contact.fax") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "niko-footer",
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
  },
};
</script>

<style lang="scss">
.footer {
  flex-grow: 0;

  &__container {
    background: #f6f6f6;
    padding: 24px 72px;
    color: #333;
    width: 100%;
    justify-content: space-between;
  }

  &__column {
    flex-direction: column;
  }

  &__heading {
    color: #000;
    min-width: 152px;
    border-bottom: 1px solid #b2b2b2;
    padding-bottom: 16px;
  }

  &__link-container {
    color: #4c4c4c;
    display: flex;
    flex-direction: column;

    &--first {
      justify-content: space-between;
      flex-grow: 1;
    }
  }

  &__link {
    margin-top: 16px;
    color: inherit !important;
  }
}
</style>
